<template>
  <div class="reports__panel--employees">
    <b-field label="Navn">
      <b-autocomplete
        v-model="employee"
        ref="autocomplete"
        :data="employeesFiltered"
        :custom-formatter="(value) => `${value.number} - ${value.name}`"
        @typing="typing"
        @select="
          (option) => {
            this.selected = option;
            this.$emit('employeeId', option ? option.id : undefined);
            this.$emit(
              'employeeNumberChanged',
              option ? option.number : undefined
            );
            this.$emit('employeeName', option ? option.name : undefined);
          }
        "
      ></b-autocomplete>
    </b-field>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "reports-panel-employees",
  props: {
    employeeNumber: {
      type: Number,
      default: undefined,
    },
    employeeName: {
      type: String,
    },
  },
  data: () => ({
    employee: undefined,
    filterText: "",
    selected: undefined,
  }),
  async mounted() {
    await this.getEmployees();
    if (this.employeeNumber) {
      const initial = this.employees.find(
        (q) => q.number == this.employeeNumber
      );
      this.$refs.autocomplete.setSelected(initial);
    }
  },
  methods: {
    ...mapActions("employees", ["getEmployees"]),
    typing: _.debounce(function(filterText) {
      this.filterText = filterText.toLowerCase();
    }),
  },
  computed: {
    ...mapGetters("employees", ["employeeApiState", "employees"]),
    employeesFiltered() {
      return this.employees.filter(
        (q) =>
          `${q.number} ${q.name}`.toLowerCase().indexOf(this.filterText) >= 0
      );
    },
  },
};
</script>

<style lang="scss">
.reports__panel--employees {
  .autocomplete {
    width: 250px;

    .input {
      padding: 5px 9px;
      height: 30px;
      background-color: #adadad;
      color: white;
      border-color: #bdbdbd;
      font-size: 14px;
    }

    .dropdown-item {
      text-align: left;

      &.is-hovered {
        background-color: #f3f3f3;
      }
    }
  }
}
</style>
